import * as React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';
import {Card, CardContent} from '@spaced-out/ui-design-system';


export const SequentialEventEditNotAllowed = () => {
  const {t} = useLabelTranslation();

  return (
    <Card testId="sequential-event-edit-not-allowed-card">
      <CardContent>
        <EmptyState
          imageVariant="calendar"
          testId="sequential-event-edit-not-allowed-empty-state"
          title={t(
            'Reschedule_or_Cancellation_not_allowed',
            'Reschedule or Cancellation not allowed',
          )}
          description={t(
            'You_cannot_reschedule_or_cancel_this_interview',
            'You cannot reschedule or cancel this interview',
          )}
        />
      </CardContent>
    </Card>
  );
};
